module.exports = __webpack_public_path__ + "img/04-1-1平台安全.42635dee.svg";